<template>
  <div class="form-controls">
    <div class="form-controls__message">
      <template v-if="errorMessage">{{ $t(errorMessage) }}</template>
      <Icon v-if="state == 'LOADING'" :spinning="true">
        <RefreshCwIcon />
      </Icon>
    </div><div class="form-controls__button">
      <button
        class="green"
        :disabled="state == 'LOADING'"
        @click="state == 'DEFAULT' && $emit('click', $event)"
      >{{$t(buttonText)}}</button>
    </div>
  </div>
</template>

<script>
  import { RefreshCwIcon } from '@zhuowenli/vue-feather-icons';
  import Icon from "./icon.vue";

  export default {
    name: "FormControls",
    components: { Icon, RefreshCwIcon },
    props: {
      errorMessage: String,
      buttonText:  !String,
      state:       !String,
    }
  }
</script>
